import {
  FormHelperText,
  Link,
  Popover,
  Stack,
  Typography,
} from '@mui/material';
import { useState } from 'react';

export const ReasonDefinitionInfoTooltip = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const isPopoverOpen = Boolean(anchorEl);

  return (
    <FormHelperText sx={{ ml: 0 }}>
      <Link
        component="button"
        variant="body2"
        underline="none"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      >
        What are Definitions?
      </Link>
      <Popover
        id="reason-definition-popover"
        sx={{
          pointerEvents: 'none',
        }}
        open={isPopoverOpen}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        disableRestoreFocus
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <Stack p="12px" maxWidth={450}>
          <Typography variant="body2" color="text.primary">
            Definitions are how your users would talk about a Reason. We use the
            Definitions associated with a Reason to find relevant feedback
            records.
          </Typography>
        </Stack>
      </Popover>
    </FormHelperText>
  );
};
